

export enum UserBulkActionMode  {
	ASYNC = 'async',
	SYNC = 'sync'
}


